<template>
  <div class='bxKbjlb' v-if='kbxmlc'>
    <div class="box noBtn">
      <div class="clear">
        <p class="cont-title lf">开标记录表</p>
        <div class="clear">
          <el-button v-if="role == 'Z'" :disabled="isNext" type="primary" class="rightButton" @click="sckbjlb">生成开标记录表</el-button>
        </div>
        <table-tem
          ref="table"
          :config="tableConfig"
          @tableBtn="tableBtn"
          @changePage="tableChangePage"
          @changePages="changePages"
        >
        </table-tem>
        <!-- <span class="lf pageNum">此次共有4家投标单位，递交投标报价3家</span> -->
      </div>
      <el-button v-if="role == 'Z'" :disabled="isNext" @click="bxNextBtn" type="primary lcNext">开标结束</el-button>
    </div>
  </div>
  <div v-else class='loading'>
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
        <span class='item-1'></span>
        <span class='item-2'></span>
        <span class='item-3'></span>
        <span class='item-4'></span>
        <span class='item-5'></span>
        <span class='item-6'></span>
        <span class='item-7'></span>
    </div>
  </div>
</template>

<script>
import tableTem from "@/components/tableTem/index.vue";
export default {
  components: {
    tableTem,
  },
  computed:{
    role() {
      return localStorage.getItem('role')?localStorage.getItem('role'):'T'
    },
    isNext() {
      return this.kbxmlc.zt == 2
    }
  },
  data() {
    return {
      waitLoading:false,
      djlcId:'',//节点流程id
      kbxmlc:'',
      tableConfig: {
        head: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "wjmc",
            title: "文件名称",
            align: "center",
          },
          {
            key: "lrsj",
            title: "生成时间",
            align: "center",
          },
          {
            title: "操作",
            align: "center",
            btns: [
              {
                type: "text",
                name: "下载",
                flag: "Download",
              },
              {
                type: "text",
                name: "查看",
                flag: "Look",
              },
            ],
          },
        ],
        data: [],
        total: 0,
        hiddenPagination: true,
        currentPage: 1,
        pageSize: 10,
        border: true,
      },
    };
  },
  created() {
    this.djlcId=this.$route.query.djlcId;
    this.getData()
  },
  methods: {
    getData() {
      let para={
        djlcId:this.djlcId,
      }
      this.waitLoading=true
      this.$api.ckkbjlb(para).then(res=>{
          if(res.data.meta.success){
            this.tableConfig.data = []
            if(res.data.data.cgzhwjResult?.bizfilesId){
              this.tableConfig.data.push(res.data.data.cgzhwjResult)
            }
            this.kbxmlc = res.data.data.kbxmlc
          }else{
            this.$message({
              type:'error',
              message:res.data.meta.message
            })
          }
          this.waitLoading=false
      }).catch(()=>{})
    },
    sckbjlb() {
      this.waitLoading=true
      this.$api.sckbjlb().then(res=>{
          if(res.data.meta.success){
            this.getData()
          }else{
            this.$message({
              type:'error',
              message:res.data.meta.message
            })
          }
          this.waitLoading=false
      }).catch(()=>{})
    },
    bxNextBtn(){
      let para={
        flag:this.kbxmlc.ycdz
      }
      this.waitLoading=true
      this.$emit('bxNextBtn',para)
    },
    // 按钮不同功能
    tableBtn(e) {
      if (e.btn.flag === "Download") this.hanldeDownload(e);
      if (e.btn.flag === "Look") this.hanldeLook(e);
    },
    // 下载
    hanldeDownload(e) {
      let para = {
        id: e.row.bizfilesId,
      };
      this.$api
        .downloadKqdjgb(para)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          let blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href);
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    // 查看
    hanldeLook(e) {
      this.$api
        .pdfshow({
          bidfilesId: e.row.pdfBizfilesId,
        })
        .then((res) => {
          this.loadPdfData(res.data, e.row.wjmc);
        })
        .catch((err) => {
          this.$message({
            message: err.statusText,
            type: "error",
          });
        });
    },
    loadPdfData(data, name) {
      const blob = new Blob([data], {
        type: "application/pdf;chartset=UTF-8",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, name);
      } else {
        const url = window.URL.createObjectURL(blob); // 创建下载的链接
        window.open(url)
      }
    },
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>

<style lang='scss' scoped>
.rightButton{
  position: absolute;
  right: 10px;
}
.clear{
  clear: initial !important;
}
.pageNum{
  position: relative;
  bottom: 50px;
}
::v-deep .el-button.el-button--text{
  color: #0060b2;
  text-decoration:none;
}
</style>
